import { LessonspaceClassroomPage } from "./page";

export default LessonspaceClassroomPage